import type { AiExecutionGraph } from '../../types/aiOperational'
import { ExecutionCheckpointPanel } from './ExecutionCheckpointPanel'
import { ExecutionStepCard } from './ExecutionStepCard'

export const ExecutionGraphView = ({ graph }: { graph?: AiExecutionGraph | null }) => {
  if (!graph) return null
  return (
    <section className="aiExecutionGraphView" aria-label="Execution graph">
      <div className="aiExecutionGraphHeader">
        <div>
          <strong>Operation graph</strong>
          <span>{graph.state.toLowerCase().replace(/_/g, ' ')} · {graph.steps.length} steps · {graph.dependencies.length} dependencies</span>
        </div>
        <span>{graph.risk.toLowerCase()} risk</span>
      </div>
      <ol className="aiExecutionGraphSteps">
        {graph.steps.slice(0, 6).map((step) => (
          <li key={step.id}>
            <ExecutionStepCard step={step} />
          </li>
        ))}
      </ol>
      <ExecutionCheckpointPanel checkpoints={graph.checkpoints} />
    </section>
  )
}
